import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${(props) => props.theme.size.static300};
  margin-top: ${(props) => props.theme.size.static500};
  align-self: stretch;

  @media (min-width: ${Breakpoints.b560}px) {
    gap: ${(props) => props.theme.size.static350};
  }
`;

export const StyledFormDescription = styled.div`
  display: flex;
  gap: ${(props) => props.theme.size.static200};
  align-self: stretch;

  > div {
    font-weight: 300;
  }
`;
